import React, { Component } from 'react';

class PersonalisedRoutine extends Component {
	render() {
		return (
			<section className="personalised__routine">
				<div className="mob__bg">
					<h1>NK’s Personalised Routine is ready!</h1>
					<img className="personalised__routine--img" src="/images/personalised-img.png" />
					<h3>Targets Acne and Blackheads</h3>
					<p className="personalised__routine--paragraph">Your search for skincare ends here! Based on your assessment and curated the right ingredients that will work for <strong>combination skin</strong> targeting acne and balckheads. Check out your products below!</p>
					<button type="button" className="btn btn-primary get__trial">GET TRIAL SET - S$15</button>
					<div className="row personalised__routine--offers">
						<div className="col-6 text-left">
							<p><img src="/images/get-money.svg" /> Get Money Back- $15 off on Full size set</p>
						</div>
						<div className="col-6 text-left">
							<p><img src="/images/ship-truck.svg" /> Free 2 days Express Shipping</p>
						</div>
					</div>
				</div>
				<div className="skin__analysis">
					<h2>Your Detailed Skin Analysis <img className="float-right mr-2" src="/images/up-arrow.svg" /></h2>
					<div className="row skin__analysis--content">
						<div className="col-sm-6">
							<div className="skin__analysis--single">
								<h5>Skin Type</h5>
								<div className="row text-center">
									<div className="col">
										<img src="/images/combination-skin.svg" />
									</div>
									<div className="col">
										<img src="/images/black-heads.svg" />
									</div>
									<div className="col">
										<img src="/images/pigmentation.svg" />
									</div>
								</div>
								<p className="mt-3 mt-lg-0">The unevennes of your skin is likely a result of historic acne and as your are still fighting acne, it is important to get it under control. First step is to commit to a microbiome friendly cleanser to rebalance and then look for anti-inflammatories that will help fight those dark spots.</p>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="skin__analysis--single">
								<h5>Skin Type</h5>
								<div className="row text-center">
									<div className="col">
										<img src="/images/sleep.svg" />
									</div>
									<div className="col">
										<img src="/images/water.svg" />
									</div>
									<div className="col">
										<img src="/images/stress.svg" />
									</div>
								</div>
								<p className="mt-3 mb-4 mb-sm-0 mt-lg-0">The unevennes of your skin is likely a result of historic acne and as your are still fighting acne, it is important to get it under control. First step is to commit to a microbiome friendly cleanser to rebalance and then look for anti-inflammatories that will help fight those dark spots.</p>
							</div>
						</div>
					</div>
				</div>
				<div className="padding15">
					<div className="product-promo-box d-block d-lg-none">
						<div className="ppb-item">
							<img className="ppb--mobile mw-100" src="/images/clean-beauty11.svg" alt="" />
						</div>
						<div className="ppb-item">
							<img className="ppb--mobile mw-100" src="/images/environmentally-friendly11.svg" alt="" />
						</div>
						<div className="ppb-item">
							<img className="ppb--mobile mw-100" src="/images/cruelty-free11.svg" alt="" />
						</div>
						<div className="clearfix"></div>
					</div>
					<div className="personalised__routine--product mt-4">
						<h1><img src="/images/dayicon.png" /> Navneet’s Day routine</h1>
						<div className="row">
							<div className="col-md-12">
								<div className="personalised__routine--product-tital">
									<span className="personalised__routine--product-tital-counts">1</span>
									<img className="mw-100" src="/images/personalised-product.png" />
									<div className="personalised__routine--product-tital-content">
										<h4>Personalised Day Moisturiser</h4>
										<div className="d-none d-md-block">
											<p><b>What is it?</b> Day cream will tackle your skin <b>dryness</b> and helps reduce <b>acne</b>, decrease deflamation and renew your skin’s surface. helps reduce<b> acne</b>, decrease deflamation</p>
											<p><b>Skin goals</b></p>
											<p>Apply 3 times a week right before sleeping</p>
										</div>
										<div className="d-block d-md-none">
											<p>Delivers balanced hydration for a healthy glow</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="personalised__routine--product-content">
									<h6>Ingredients for targeting acne</h6>
									<ul className="row">
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
									</ul>
									<span className="text-right w-100 d-inline-block"><b><u>Full Ingredients List</u></b></span>
								</div>
							</div>
						</div>
					</div>
					<div className="personalised__routine--product mt-4">
						<div className="row">
							<div className="col-md-12">
								<div className="personalised__routine--product-tital">
									<span className="personalised__routine--product-tital-counts">2</span>
									<img className="mw-100" src="/images/personalised-product.png" />
									<div className="personalised__routine--product-tital-content">
										<h4>Personalised Day Moisturiser</h4>
										<div className="d-none d-md-block">
											<p><b>What is it?</b> Day cream will tackle your skin <b>dryness</b> and helps reduce <b>acne</b>, decrease deflamation and renew your skin’s surface. helps reduce<b> acne</b>, decrease deflamation</p>
											<p><b>Skin goals</b></p>
											<p>Apply 3 times a week right before sleeping</p>
										</div>
										<div className="d-block d-md-none">
											<p>Delivers balanced hydration for a healthy glow</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="personalised__routine--product-content">
									<h6>Ingredients for targeting acne</h6>
									<ul className="row">
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
									</ul>
									<span className="text-right w-100 d-inline-block"><b><u>Full Ingredients List</u></b></span>
								</div>
							</div>
						</div>
					</div>
					<div className="personalised__routine--product mt-5">
						<h1><img src="/images/nighticon.png" /> Navneet’s Night routine</h1>
						<div className="row">
							<div className="col-md-12">
								<div className="personalised__routine--product-tital">
									<span className="personalised__routine--product-tital-counts">1</span>
									<img className="mw-100" src="/images/personalised-product.png" />
									<div className="personalised__routine--product-tital-content">
										<h4>Personalised Day Moisturiser</h4>
										<div className="d-none d-md-block">
											<p><b>What is it?</b> Day cream will tackle your skin <b>dryness</b> and helps reduce <b>acne</b>, decrease deflamation and renew your skin’s surface. helps reduce<b> acne</b>, decrease deflamation</p>
											<p><b>Skin goals</b></p>
											<p>Apply 3 times a week right before sleeping</p>
										</div>
										<div className="d-block d-md-none">
											<p>Delivers balanced hydration for a healthy glow</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="personalised__routine--product-content">
									<h6>Ingredients for targeting acne</h6>
									<ul className="row">
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
									</ul>
									<span className="text-right w-100 d-inline-block"><b><u>Full Ingredients List</u></b></span>
								</div>
							</div>
						</div>
					</div>
					<div className="personalised__routine--product mt-4">
						<div className="row">
							<div className="col-md-12">
								<div className="personalised__routine--product-tital">
									<span className="personalised__routine--product-tital-counts">2</span>
									<img className="mw-100" src="/images/personalised-product.png" />
									<div className="personalised__routine--product-tital-content">
										<h4>Personalised Day Moisturiser</h4>
										<div className="d-none d-md-block">
											<p><b>What is it?</b> Day cream will tackle your skin <b>dryness</b> and helps reduce <b>acne</b>, decrease deflamation and renew your skin’s surface. helps reduce<b> acne</b>, decrease deflamation</p>
											<p><b>Skin goals</b></p>
											<p>Apply 3 times a week right before sleeping</p>
										</div>
										<div className="d-block d-md-none">
											<p>Delivers balanced hydration for a healthy glow</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="personalised__routine--product-content">
									<h6>Ingredients for targeting acne</h6>
									<ul className="row">
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
										<li className="col-lg-4">
											<img src="/images/arnica.png" />
											<strong>DERMOCHLORELLA</strong> Glycerin & Aqua & Chlorella Vulgaris Extract
										</li>
									</ul>
									<span className="text-right w-100 d-inline-block"><b><u>Full Ingredients List</u></b></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="result__sidebar d-block d-lg-none">
					<h1 className="result__sidebar--heading">Hassle-free personalised routine that works for you</h1>
					<button type="button" className="btn btn-primary try__now">TRY NOW - S$15</button>
					<p className="text-center m-0 mb-1"><img src="/images/get-back.svg" /> <strong>Get back $15 on upgrading to</strong> Full Set</p>
					<p className="text-center m-0"><img src="/images/ship-truck.svg" /> <strong>Free</strong> Shipping</p>
				</div>
				<div className="padding15">
					<div className="howtouse">
						<h1>How to Use</h1>
						<div className="row">
							<div className="col-sm-6">
								<p><img src="/images/day-icon.svg" /> Day Routine</p>
								<img className="mw-100" src="/images/assessment/dayroute.svg" />
							</div>
							<div className="col-sm-6">
								<p><img src="/images/night-icon.png" /> Night Routine</p>
								<img className="mw-100" src="/images/assessment/nightroute.svg" />
							</div>
						</div>
					</div>
				</div>

			</section>
		);
	}
}


export default PersonalisedRoutine;